import { registerCapability } from '../../platform/capability-registry';
import { resolveCommandArgsNormalPaths } from '../command-args-normal';
import { MaasCommandArgsNormalBlock } from './MaasCommandArgsNormalBlock';
import { MAAS_COMMAND_ARGS_NORMAL_FIELD_KEY_LIST } from './fieldKeys';
import type { MaasCommandArgsNormalBlockOptions } from './types';

registerCapability<MaasCommandArgsNormalBlockOptions>({
  key: 'maas-command-args-normal',
  fields: [...MAAS_COMMAND_ARGS_NORMAL_FIELD_KEY_LIST],
  component: MaasCommandArgsNormalBlock,
  defaultPaths: (prefix) => resolveCommandArgsNormalPaths(prefix || 'initCommand'),
  resolvePaths: (prefix, options) => resolveCommandArgsNormalPaths(options?.pathPrefix ?? prefix ?? 'initCommand'),
});
